import {InjectionToken} from '@angular/core';
import {ModalConfig} from '@shared/components/modal/modal.config';

export const MODAL_CONFIG = new InjectionToken<ModalConfig>(
  'MODAL_CONFIG'
);
